export const NewContractorGetters = {
  NewContractor: 'getNewContractor'
};
